import * as React from 'react';
import MNewOrderPageView from '../layouts/MNewOrderPageView';
// import { RowDataLive } from 'src/reducers/liveorderfile';
import { RowDataManufactur } from 'src/reducers/manufactur';
// import { UserDetail } from '../../reducers/user';

export interface MNewOrderPageViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    mNewOrderData: RowDataManufactur[];
    reload: () => void;
    // onRowClick: (orderid: string, rowData: string) => void;
    // onDownloadClick: (orderno: string, fileName: string) => void;
    submitCancel: (column: Object) => void;
}

class MNewOrdersPage extends React.Component<MNewOrderPageViewProps> {
    render() {
        return (
            <MNewOrderPageView
                // onRowClick={this.props.onRowClick}
                mNewOrderData={this.props.mNewOrderData}
                reload={this.props.reload}
                submitCancel={this.props.submitCancel}
            // onDownloadClick={this.props.onDownloadClick}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default MNewOrdersPage;



// WEBPACK FOOTER //
// ./src/components/MNewOrdersPage/MNewOrdersPage.tsx